import React from 'react';
import { Blogs } from '../components/Blogs';
import { CustomerReviews } from '../components/CustomerReviews';
import { Hero } from '../components/Hero';
import { HomeOverview } from '../components/HomeOverview';
import { InstagramFeed } from '../components/InstagramFeed';
import { PlanningEssentials } from '../components/PlanningEssentials';
import { TripGrid } from '../components/TripGrid';
export function TrekPage() {
  return <main data-id="element-694" data-mp="1wvgaxq7vsyqr">
      <Hero data-id="element-695" data-mp="1wuy8gbumloae" />
      <HomeOverview data-id="element-696" data-mp="1wycd5qqri9l0" />
      <TripGrid data-id="element-697" data-mp="20xute97n1whi" />
      <PlanningEssentials data-id="element-698" data-mp="20ycsreplkqtn" />
      <CustomerReviews data-id="element-699" data-mp="20ymgswr30nwp" />
      <Blogs data-id="element-700" data-mp="20vqhp53hzt6o" />
      <InstagramFeed data-id="element-701" data-mp="20vi8poahx80r" />
    </main>;
}